const de = {
  avisoLegal: "Unverbindlicher Entwurf, erstellt aus den in NuvliPro erfassten Daten. Er ersetzt keine professionelle Beratung. Prüfen Sie ihn mit Ihrem Steuerberater, bevor Sie ihn einreichen.",
  lockPago: "Exporte für den Steuerberater sind eine kostenpflichtige Funktion.",
  imp: { IVA: "MwSt.", IGIC: "IGIC", IPSI: "IPSI" },
  ter: { comun: "Allgemeines Steuergebiet", canarias: "Kanarische Inseln", ceuta_melilla: "Ceuta und Melilla", foral_pv: "Baskenland", foral_navarra: "Navarra" },
  tipo: { autonomo: "Selbstständig (natürliche Person)", sociedad: "Gesellschaft" },
  q: { 1: "Q1 · Jan–Mär", 2: "Q2 · Apr–Jun", 3: "Q3 · Jul–Sep", 4: "Q4 · Okt–Dez" },
  periodoT: "Q{{n}} {{year}}",
  periodoP: "Zahlung {{n}} {{year}}",
  sub: "{{imp}} und Einkommensteuer pro Quartal und Jahresübersicht",
  pie: "Die Beträge werden automatisch aus Ihren ausgestellten Rechnungen und erfassten Ausgaben pro Quartal berechnet.",
  regimen: {
    proTitulo: "Pro-Tarif:",
    proTexto: "automatisches Steuerregime nach Gebiet (MwSt., IGIC und Foral-Finanzämter), Formular 420 auf den Kanaren, Formular 202 für Gesellschaften, Formular 111, Fristerinnerungen und Prüfung der Datenqualität.",
    pasarPro: "Zu Pro wechseln",
    modelo: " (Formular {{m}})",
    pagos: "Vorauszahlungen: Formular {{m}}",
    corregido: "Manuell korrigiert · ändern",
    detectado: "Automatisch erkannt · korrigieren",
    faltan: "Ihre steuerliche Angabe fehlt ({{que}}): Bis Sie sie ergänzen, gehen wir von allgemeinem Steuergebiet und Selbstständigkeit aus.",
    cp: "Postleitzahl", nif: "NIF/CIF", y: " und ",
    foral: "Ihr Steuersitz liegt in {{nombre}}: MwSt. und Vorauszahlungen werden bei der {{hacienda}} mit eigenen Foral-Formularen und -Fristen eingereicht. Dieser Entwurf dient als Orientierung; die Erklärung erstellt Ihr Steuerberater.",
    ipsi: "In Ceuta und Melilla gilt die IPSI statt der MwSt. NuvliPro berechnet sie noch nicht: Bitten Sie Ihren Steuerberater, die Erklärung zu erstellen.",
  },
  card: {
    baseVentas: "Umsatz netto", baseGastos: "Ausgaben netto", rep: "{{imp}} auf Umsätze", sop: "Vorsteuer ({{imp}})",
    irpf: "Einbehaltene ESt. (IRPF)", horas: "Gearbeitete Stunden", bases: "Bemessung nach {{imp}}-Satz", base: "{{imp}} {{pct}}% · Basis",
    resultado: "Ergebnis {{imp}} ({{estado}})", aIngresar: "zu zahlen", aCompensar: "zu verrechnen",
    igicCanarias: "IGIC · Projekte auf den Kanaren", ivaFuera: "MwSt. · Projekte außerhalb der Kanaren",
    ipsiRep: "IPSI auf Umsätze", ipsiAviso: "IPSI ohne Berechnung: Ihr Steuerberater erstellt sie.",
    isp: "Umkehr der Steuerschuldnerschaft · separat", ispEmitidas: "Ausgestellt (Basis, ohne Steuer)", ispRecibidas: "Erhalten (Basis)",
    ispCuota: "Selbst berechnete Steuer (wird erklärt und abgezogen)",
  },
  btn: {
    docGestoria: "Berater-Dok.", docAnual: "Berater-Dok. (jährlich)", enviar: "Senden", m: "F.{{m}}", modelo: "Formular {{m}}",
    m420Pro: "Formular 420: Pro-Tarif", excel: "Excel", ver130: "130 ansehen",
  },
  anual: { titulo: "Jahresübersicht {{year}}", ipsi: "IPSI auf Umsätze (ohne Berechnung)", resultado: "Jahresergebnis {{imp}}" },
  doc: { gestoria: "Dokument für den Steuerberater", modelo: "Formular {{m}}" },
  toast: {
    generado: "{{doc}} erstellt", trimestre: " (Q{{n}})", anual: " (Jahr {{year}})", error: "Konnte nicht erstellt werden: {{doc}}",
    excelOk: "Bericht {{year}} für den Steuerberater exportiert (XLSX)", excelError: "Der Bericht konnte nicht exportiert werden",
    m130Error: "Formular 130 konnte nicht berechnet werden", reduccionError: "Die Minderung konnte nicht gespeichert werden",
  },
  m130: {
    titulo: "Formular 130 — Einkommensteuer", acum: "(kumuliert Q{{n}})", anual: "(Jahr {{year}})",
    desc: "Kumulierte Vorauszahlung des Jahres abzüglich Einbehalte und der in früheren Quartalen gezahlten Beträge.",
    ingresos: "Anrechenbare Einnahmen (kumuliert)", gastos: "Abzugsfähige Ausgaben (kumuliert)", rendimiento: "Nettoertrag",
    reduccion: "Minderung {{pct}} % schwer belegbare Ausgaben", pago: "Vorauszahlung ({{pct}} %)",
    retenciones: "Erlittene Einbehalte", anteriores: "Zahlungen früherer Quartale",
    aIngresar: "Zu zahlendes Ergebnis", negativo: "Negatives Ergebnis (zu zahlen: 0 €)",
    marcar: "Minderung von {{pct}} % für schwer belegbare Ausgaben anwenden (max. {{max}}/Jahr). Sprechen Sie mit Ihrem Steuerberater.",
    cerrar: "Schließen", pdf: "PDF herunterladen",
  },
  m202: {
    titulo: "Formular 202 — Vorauszahlungen {{year}} (Schätzung)",
    desc: "Körperschaftsteuer: {{pct}} % des kumulierten Jahresgewinns. Ihr Steuerberater kann eine andere Methode verwenden.",
    plazo: "Zahlung {{p}} · einzureichen vom 1. bis 20. {{mes}}", mes: { 1: "April", 2: "Oktober", 3: "Dezember" },
    tramo: { 3: "Jan–Mär", 9: "Jan–Sep", 11: "Jan–Nov" }, beneficio: "Kumulierter Gewinn ({{tramo}})",
    cuota: "{{pct}} % des Gewinns", menos: "Einbehalte und frühere Zahlungen", estimacion: "Geschätzter Zahlbetrag",
  },
  m111: {
    titulo: "Formular 111 — Einbehalte {{year}}",
    desc: "Lohnsteuereinbehalte (geben Sie selbst ein) und Einbehalte bei Freiberuflern, die Sie bezahlen (aus Ihren Ausgaben).",
    nominas: "Lohnsteuereinbehalte (manuell)", profesionales: "Freiberufler: {{n}} Empfänger, Basis {{base}}",
    total: "Gesamt zu zahlen", guardado: "Lohnsteuereinbehalte für Q{{n}} gespeichert",
    errorGuardar: "Der Betrag konnte nicht gespeichert werden", invalido: "Geben Sie einen gültigen Betrag ein, z. B. 1.234,56",
  },
  enviar: {
    titulo: "Q{{n}} {{year}} an Ihren Steuerberater senden",
    desc: "Er erhält eine E-Mail mit diesen PDFs im Anhang. Antwortet er, geht die E-Mail an Sie.",
    email: "E-Mail des Steuerberaters", placeholder: "berater@beispiel.de", boton: "Senden", ok: "Q{{n}} {{year}} an {{email}} gesendet ({{docs}} PDF)",
    error: "Prüfen Sie die E-Mail des Steuerberaters",
  },
  avisos: {
    plazos: "Nächste Fristen", sinPlazos: "Keine anstehenden Fristen.",
    forales: "Foral-Fristen: Die Formulare werden bei Ihrem Foral-Finanzamt eingereicht und von Ihrem Steuerberater erstellt.",
    modelos: "Formulare {{m}}", rango: "{{periodo}}: vom {{desde}} bis {{hasta}}",
    hoy: "Endet heute", unDia: "Noch 1 Tag", dias: "Noch {{n}} Tage",
    recordatorio: "Wir erinnern Sie 10 Tage vor Ablauf jeder Frist per Benachrichtigung und E-Mail.",
    calidad: "Datenqualität {{year}}", ok: "Alles in Ordnung: In Ihren Rechnungen dieses Jahres fehlen keine Daten.",
    revisar: "Prüfen", exenta: "Als steuerfrei markieren", exentaOk: "Ausgabe als steuerfrei markiert", exentaError: "Die Ausgabe konnte nicht markiert werden",
  },
  calidad: {
    facturas_nif: "Ausgangsrechnungen ohne oder mit ungültiger Kunden-NIF",
    facturas_cp_obra: "Projektrechnungen ohne Postleitzahl des Projekts (in der Projektkarte ergänzen)",
    gastos_sin_impuesto: "Eingangsrechnungen ohne ausgewiesene Steuer (MwSt. oder IGIC bei 0)",
    gastos_nif: "Eingangsrechnungen ohne oder mit ungültiger Lieferanten-NIF",
  },
  ajustes: {
    titulo: "Steuerregime (Quartalsbericht)", det1: "Automatisch erkannt:", det2: "anhand Ihrer Postleitzahl und",
    det3: "anhand Ihrer NIF/CIF. Ändern Sie es nur, wenn es nicht stimmt.",
    nota: "Diese Änderung betrifft nur den Quartalsbericht. Neue Rechnungen schlagen die Steuer weiterhin nach Ihrer Postleitzahl und der des Kunden vor.",
    territorio: "Steuergebiet", tipo: "Art des Steuerpflichtigen", automatico: "Automatisch ({{x}})",
    autonomo130: "Selbstständig (Formular 130)", sociedad202: "Gesellschaft (Formular 202)",
    bloqueado: "Das automatische Regime gehört zum Pro-Tarif.", guardado: "Steuerregime gespeichert", error: "Konnte nicht gespeichert werden",
  },
};

export default de;
